import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseEntityResource } from '../../core/abstractions/base-entity.resource';
import { AlertTypeModel } from '../../models/alert-type.model';
import { AlertModel } from '../../models/alert.model';
import { ApiResponseModel } from '../../models/core/api-response.model';
import { ResourceConfig } from '../../models/core/resource.config';
import { DynamicFormFieldModel } from '../../models/dynamic-form-field.model';

@Injectable({
    providedIn: 'root'
})
export class AlertsResource extends BaseEntityResource<AlertModel> {
    constructor() {
        super(new ResourceConfig({ baseController: 'alerts' }));
    }

    getAll(): Observable<ApiResponseModel<AlertModel[]>> {
        return this._requestService.makeGet<ApiResponseModel<AlertModel[]>>(this.getUrl(''));
    }

    getAlertTypes(): Observable<ApiResponseModel<AlertTypeModel[]>> {
        return this._requestService.makeGet<ApiResponseModel<AlertTypeModel[]>>(this.getUrl('alert-types'));
    }

    getAlertTypeParameters(alertTypeName: string): Observable<ApiResponseModel<DynamicFormFieldModel[]>> {
        return this._requestService.makeGet<ApiResponseModel<DynamicFormFieldModel[]>>(
            this.getUrl(`alert-type/${alertTypeName}/parameters`)
        );
    }
}
